import React from 'react';

// Datos de contacto comercial. Antes eran una imagen (contacto.webp): no se
// podía seleccionar ni copiar, los lectores de pantalla no la leían y Google
// no la indexaba. Como texto, el correo y el teléfono son enlaces directos.
const CONTACTOS = [
  { correo: 'ybornaz@comuintegral.com', telefono: '902552940' },
  { correo: 'dmolero@comuintegral.com', telefono: '958313928' },
];

const CORREO_REVISTA = 'revistacamaraaqp@cciarequipa.org';
const ENLACE_REVISTA = 'https://www.camara-arequipa.org.pe/revista/';

const IconoCorreo = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7} aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path strokeLinecap="round" strokeLinejoin="round" d="m4 7.5 8 6 8-6" />
  </svg>
);

const IconoWhatsApp = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.9-4.45 9.9-9.91C21.95 6.45 17.5 2 12.04 2Zm5.8 14.02c-.25.69-1.44 1.32-1.99 1.36-.53.05-1.02.24-3.44-.72-2.9-1.14-4.74-4.1-4.88-4.29-.14-.19-1.16-1.55-1.16-2.95 0-1.4.73-2.09.99-2.37.26-.29.57-.36.76-.36h.54c.18 0 .42-.07.65.5.25.6.84 2.08.91 2.23.07.15.12.32.02.51-.09.19-.14.31-.28.48l-.42.48c-.14.14-.28.29-.12.57.16.28.71 1.17 1.53 1.9 1.05.94 1.94 1.23 2.21 1.37.28.14.44.12.6-.07.17-.19.7-.81.88-1.09.19-.29.37-.24.63-.14.25.09 1.6.75 1.87.89.28.14.46.21.53.33.07.11.07.66-.18 1.35Z" />
  </svg>
);

const ContactoAnuncia = () => (
  <section className="ed-contacto" aria-labelledby="ed-contacto-titulo">
    <div className="ed-contacto__cuerpo">
      <p className="ed-contacto__sobretitulo">Anuncia con nosotros</p>
      <h2 id="ed-contacto-titulo" className="ed-contacto__titulo">Contáctanos</h2>
      <span className="ed-contacto__regla" aria-hidden="true" />

      <ul className="ed-contacto__lista">
        {CONTACTOS.map(({ correo, telefono }) => (
          <li key={correo} className="ed-contacto__tarjeta">
            <a className="ed-contacto__fila" href={`mailto:${correo}`}>
              <span className="ed-contacto__icono"><IconoCorreo /></span>
              <span className="ed-contacto__dato">{correo}</span>
            </a>
            <a className="ed-contacto__fila" href={`https://wa.me/51${telefono}?text=${encodeURIComponent('Hola, me interesa anunciar en la revista de la CCIA')}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Escribir por WhatsApp al ${telefono}`}
            >
              <span className="ed-contacto__icono"><IconoWhatsApp /></span>
              <span className="ed-contacto__dato">{telefono}</span>
            </a>
          </li>
        ))}
      </ul>

      {/* Marca de puntos decorativa, como en la lámina original */}
      <span className="ed-contacto__puntos" aria-hidden="true" />
    </div>

    <div className="ed-contacto__pie">
      <div className="ed-contacto__revista">
        <p>Encuentra nuestra revista digital</p>
        <a
          className="ed-contacto__boton"
          href={ENLACE_REVISTA}
          target="_blank"
          rel="noopener noreferrer"
        >
          Ver revista digital
        </a>
      </div>

      <div className="ed-contacto__marca">
        <a className="ed-contacto__correo-revista" href={`mailto:${CORREO_REVISTA}`}>
          {CORREO_REVISTA}
        </a>
        <a
          className="ed-contacto__logo"
          href={ENLACE_REVISTA}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Ir a la web de la revista Cámara AQP"
        >
          <img src="/logo_revista.webp" alt="Cámara AQP, revista institucional de la CCIA" loading="lazy" decoding="async" />
        </a>
      </div>
    </div>
  </section>
);

export default ContactoAnuncia;
